import { Decimal } from 'decimal.js';
import { CUBICMETERS_TO_CUBICFEET, UD_DESCRIPTIONS, UD_TYPES } from './constants';
import { getUdDescriptionInGrammarTypeByLang, isCatalogUSA, throwError, toDecimalPlaces } from './utils';

const _cubicFeetTocubicMeters = (m: number) => Number(new Decimal(m).times(CUBICMETERS_TO_CUBICFEET));
const _cubicMetersToCubicFeet = (m: number) => Number(new Decimal(m).div(CUBICMETERS_TO_CUBICFEET));

const UD_TYPES_TO_CUBICFEET = {
  [UD_TYPES.CUBICMETERS]: {
    toCubicFeet: _cubicMetersToCubicFeet,
  },
};

const UD_TYPES_TO_CUBICMETERS = {
  [UD_TYPES.CUBICFEET]: {
    toCubicMeters: _cubicFeetTocubicMeters,
  },
};

type TUdType = UD_TYPES.CUBICMETERS | UD_TYPES.CUBICFEET;

export const toCubicFeet = (value: number, udType: TUdType) => {
  if (!UD_TYPES_TO_CUBICFEET[udType]) {
    throwError();
  }

  return UD_TYPES_TO_CUBICFEET[udType].toCubicFeet(value);
};

export const toCubicMeters = (value: number, udType: TUdType) => {
  if (!UD_TYPES_TO_CUBICMETERS[udType]) {
    throwError();
  }

  return UD_TYPES_TO_CUBICMETERS[udType].toCubicMeters(value);
};

export const toObjectVolumeByCatalog = (catalogId: number, value: number, udType: TUdType) => {
  if (!UD_TYPES_TO_CUBICFEET[udType]) {
    throwError();
  }

  const cubicFeet = isCatalogUSA(catalogId) ? toDecimalPlaces(toCubicFeet(value, udType), 4) : undefined;

  const enDescription = cubicFeet
    ? `${cubicFeet} ${getUdDescriptionInGrammarTypeByLang(cubicFeet, UD_DESCRIPTIONS[UD_TYPES.CUBICFEET].en)}`
    : `${value} ${getUdDescriptionInGrammarTypeByLang(value, UD_DESCRIPTIONS[udType].en)}`;

  const esDescription = cubicFeet
    ? `${cubicFeet} ${getUdDescriptionInGrammarTypeByLang(cubicFeet, UD_DESCRIPTIONS[UD_TYPES.CUBICFEET].es)}`
    : `${value} ${getUdDescriptionInGrammarTypeByLang(value, UD_DESCRIPTIONS[udType].es)}`;

  const shortDescription = cubicFeet
    ? `${cubicFeet} ${UD_DESCRIPTIONS[UD_TYPES.CUBICFEET].short}`
    : `${value} ${UD_DESCRIPTIONS[udType].short}`;

  return {
    value,
    ud: udType,
    description: {
      en: enDescription,
      es: esDescription,
      de: enDescription,
      fr: enDescription,
      it: enDescription,
      us: enDescription,
    },
    shortDescription: {
      en: shortDescription,
      es: shortDescription,
      de: shortDescription,
      fr: shortDescription,
      it: shortDescription,
      us: shortDescription,
    },
  };
};
